import { useEffect, useRef, useState } from 'react';

// true por `ms` depois que `value` muda (nunca no mount). Use com a classe `jds-flash`.
export function useChangedFlag(value, ms = 900) {
  const prev = useRef(value);
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    if (prev.current === value) return undefined;
    prev.current = value;
    setChanged(true);
    const timer = setTimeout(() => setChanged(false), ms);
    return () => clearTimeout(timer);
  }, [value, ms]);

  return changed;
}
